import React, { useEffect, useState } from "react";
import {
  Grid,
  TextField,
  Typography,
  Card,
  CardContent,
  Avatar,
  Button,
  Snackbar,
  Alert,
} from "@mui/material";
import { getDoc, doc } from "firebase/firestore"; // Import deleteDoc
import { db } from "../../../firebase";
import { useLocation } from "react-router-dom";

const Fullview = () => {
  const [message, setMessage] = useState({});
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertSeverity, setAlertSeverity] = useState("success");
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const messageId = params.get("uid");
    if (messageId) {
      fetchMessage(messageId);
    }
  }, [location.search]);

  const fetchMessage = async (messageId) => {
    try {
      const docRef = doc(db, "wallet", messageId);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        const messageData = docSnap.data();
        // Convert createdAt string to Date object
        messageData.createdAt = new Date(messageData.createdAt);
        setMessage(messageData);
      } else {
        console.log("No such document!");
      }
    } catch (error) {
      console.error("Error fetching message:", error);
    }
  };


  const handleAlertClose = () => {
    setShowAlert(false);
  };

  return (
    <div className="App">
      <main style={{ padding: "20px 5px" }}>
        <Grid container justifyContent="center">
          <Grid item xs={12} sm={10} md={8} lg={6}>
            <Avatar
              alt={message.userName || "User"}
              src={message.userImage || "/placeholder.jpg"}
              style={{
                width: 100,
                height: 100,
                margin: "0 auto",
                marginBottom: 20,
              }}
            />
            <Card style={{ margin: "0 auto" }}>
              <CardContent>
                <Typography
                  variant="h6"
                  color="#272727"
                  align="center"
                  gutterBottom
                >
                  Wallet
                </Typography>
                <Grid container spacing={2}>

                  <Grid item xs={12}>
                    <TextField
                      label="Coins"
                      name="coin"
                      value={message.coins || ""}
                      fullWidth
                      variant="outlined"
                      rows={4}
                      disabled
                    />
                  </Grid>
               

                </Grid>
               
              </CardContent>
            </Card>
            <Snackbar
              open={showAlert}
              autoHideDuration={6000}
              onClose={handleAlertClose}
            >
              <Alert
                onClose={handleAlertClose}
                severity={alertSeverity}
                sx={{ width: "100%" }}
              >
                {alertMessage}
              </Alert>
            </Snackbar>
          </Grid>
        </Grid>
      </main>
    </div>
  );
};

export default Fullview;
